export default "__VITE_ASSET__BoWe9_Md__"